module.exports = __webpack_public_path__ + "img/gt.58f35af.svg";